import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CabinetShelfRefDto, FiscalFileLocationDto } from '@cradua/data';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-cabinet-shelf-ref',
  templateUrl: './cabinet-shelf-ref.component.html',
  styleUrls: ['./cabinet-shelf-ref.component.scss']
})
export class CabinetShelfRefComponent implements OnInit {
  @Input() cabinetshelfrefs: CabinetShelfRefDto[];
  @Input() fiscalfilelocations: FiscalFileLocationDto[];
  cabinetshelfrefForm: FormGroup;
  cabinetshelfrefFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<CabinetShelfRefDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  filteredCabinetShelfRef: Array<any> = [];
  status: boolean;
  selectedCabinetShelfRefId: any;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.createCabinetShelfRefForm();
  }

  createCabinetShelfRefForm() {
    this.cabinetshelfrefFormArray = this.fb.group({ CabinetShelfRefs: this.fb.array([]) });
    this.cabinetshelfrefForm = this.fb.group({
      CabinetShelfRefNo: ['', Validators.required],
        FileLocationId: this.selectedCabinetShelfRefId,
        id: null
    });
  }


  // method to display companies
  setCabinetShelfRef() {
    const control = this.cabinetshelfrefFormArray.controls.CabinetShelfRefs as FormArray;
    this.filteredCabinetShelfRef.forEach((e) => {
      control.push(
        this.fb.group({
          CabinetShelfRefNo: e.CabinetShelfRefNo,
          FileLocationId: e.FileLocationId,
          id: e.id,
        })
      );
    });
  }

   // method to add Company
   addCabinetShelfRef(cabinetshelfref: CabinetShelfRefDto) {
    console.log('cabinetshelfref');
    const control = this.cabinetshelfrefFormArray.controls.CabinetShelfRefs as FormArray;
    control.insert(
      0,
      this.fb.group({
        CabinetShelfRefNo: cabinetshelfref.CabinetShelfRefNo,
        FileLocationId: this.selectedCabinetShelfRefId,

      })
    );
  }


  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.cabinetshelfrefFormArray.controls.CabinetShelfRefs as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter cabinetshelfref
  selectFiscalFileLocation(event: string) {
    console.log('event', event);
    console.log('e', this.cabinetshelfrefs);
    this.filteredCabinetShelfRef = this.cabinetshelfrefs.filter((s) => s.FileLocationId === event);
    this.selectedCabinetShelfRefId = event;
    const control = this.cabinetshelfrefFormArray.controls
      .CabinetShelfRefs as FormArray;

    if (this.filteredCabinetShelfRef.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setCabinetShelfRef();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  print(event: any) {
    window.print();
  }
  // method to delete company from arrary list
  deleteCabinetShelfRef(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.cabinetshelfrefFormArray.controls.CabinetShelfRefs as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.cabinetshelfrefs.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.cabinetshelfrefs[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }


  addNew(formValue: CabinetShelfRefDto) {
    if(this.cabinetshelfrefForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.cabinetshelfrefFormArray.get('CabinetShelfRefs')['controls'][this.selectedIndex].patchValue({CabinetShelfRefNo: formValue.CabinetShelfRefNo});
    } else {
      this.addCabinetShelfRef(formValue);
    }
    this.selectedIndex = null;
    this.cabinetshelfrefForm.reset()
  }

  onEdit(index, value: CabinetShelfRefDto) {
    this.selectedIndex = index;
    this.cabinetshelfrefForm.patchValue({CabinetShelfRefNo: value.CabinetShelfRefNo});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.cabinetshelfrefForm.reset();
  }


  onSubmit(formValue: any) {
    formValue.type = 'cabinetshelfref';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length > 0) {
      this.filteredDelete.unshift('cabinetshelfref');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }


}
